import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Layout, Card, Row, Col, Button, Image } from "antd";
import HamburgerNavbar from "../../Components/HamburgerNavbar";
import Footer from "../../Components/Footer";
import apiInstance from "../../services/axiosInstance";

const { Content } = Layout;

const ValidateCertificate = () => {
  const { id } = useParams();
  const [certificateData, setCertificateData] = useState(null);

  const fetchCertificate = async () => {
    await apiInstance.get(`/student/certificateDetails/${id}`)
    .then((response) => response.data)
    .then((data) => 
    {
      let code = data.certificateId.split("-")[1] + "_" +data.certificateId.split("-")[2];
      data.studentCode = code;
      data.createdAt = new Date(data.createdAt)
      setCertificateData(data);
    })
    .catch((error) => console.error("Error fetching certificate details:", error))
  }

  useEffect(() => {
    fetchCertificate();
  }, [id]);

  return (
    <>
      {/* <HamburgerNavbar /> */}
      <Layout>
        <Content style={{ padding: "15px 29px" }}>
          <Row gutter={16}>
            <Col span={12}>
              <div>
                {certificateData && (
                  <Card title="Certificate Details">
                    <p>
                      <b>Student Name:</b> {certificateData.name}
                    </p>
                    <p>
                      <b>Batch:</b> {certificateData.batch}
                    </p>
                    <p>
                        <b>Date Generated: </b> {certificateData && certificateData.createdAt.toLocaleString("en-GB")}
                    </p>
                    <p>
                      <b>Student Code: </b> {certificateData.studentCode.toUpperCase()}
                    </p>
                    <p>
                      <b>Course Completed: </b> {certificateData.courseCompleted}
                    </p>
                  </Card>
                )}
              </div>
            </Col>
            <Col span={12}>
              <div style={{ height: "70vh"}}>
                    <Image
                    className="batchDetailTable__certificate"
                    src={certificateData?.path}
                    width={"80%"}
                    preview={{
                      mask: <div style={{ background: "rgba(0, 0, 0, 0.5)" }} />,
                    }}
                    alt="Certificate"
                  />
                {/* You can add content to the right side */}
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
      {/* <Footer /> */}
    </>
  );
};

export default ValidateCertificate;
